import TerminalCreate from './TerminalCreate';
import TerminalEdit from './TerminalEdit';

export default {
  create: TerminalCreate,
  edit: TerminalEdit,
};
